module.exports = ".Blue{\r\n    color:blue;    \r\n}\r\n\r\n.Green{\r\n    color:brown\r\n}\r\n\r\n.Red{\r\n    color:red;\r\n}\r\n\r\n.DGreen{\r\n    color: green\r\n}\r\n\r\n.yellow{\r\n    color: yellow\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/employee-claims/Medical-Reimbursment/medical-reimburesment-grid/medical-reimburesment-grid.component.css
// module id = ./src/app/hrms/employee-claims/Medical-Reimbursment/medical-reimburesment-grid/medical-reimburesment-grid.component.css
// module chunks = main